import { httpClient } from '@/shared/api/httpClient';

export type ColaboradorResumo = {
  id: string;
  nome: string;
  cargo: string | null;
  email: string | null;
  telefone: string | null;
  ativo: boolean;
  /** true quando já tem PIN de caixa cadastrado. O PIN nunca é devolvido. */
  temPin: boolean;
  /** true enquanto o cadastro/edição não foi confirmado pelo servidor. */
  syncPendente: boolean;
};

export type SalvarColaboradorRequest = {
  nome: string;
  cargo?: string | null;
  email?: string | null;
  telefone?: string | null;
  ativo?: boolean;
};

export type CriarColaboradorResponse = { id: string };

export const colaboradoresApi = {
  listar: () => httpClient.get<ColaboradorResumo[]>('/api/colaboradores'),
  criar: (cmd: SalvarColaboradorRequest) =>
    httpClient.post<CriarColaboradorResponse>('/api/colaboradores', cmd),
  atualizar: (id: string, cmd: SalvarColaboradorRequest) =>
    httpClient.put<void>(`/api/colaboradores/${id}`, cmd),
  excluir: (id: string) => httpClient.delete<void>(`/api/colaboradores/${id}`),
  /** Define (ou remove, com `null`) o PIN usado para abrir e fechar caixa. */
  definirPin: (id: string, pin: string | null) =>
    httpClient.post<void>(`/api/colaboradores/${id}/pin`, { pin }),
};
